import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsRolesResolverErrorStatesEnum {
    GetRolesFailed = ErrorStateScheduleEnum.PanelSettingsRolesResolverStatesStartIndex
}
